import React from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';

interface Props {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  /** Buttons or filters on the right; they move under the title when there is no room. */
  actions?: React.ReactNode;
  sx?: SxProps<Theme>;
}

/** The title row every page starts with. */
const PageHeader: React.FC<Props> = ({ title, subtitle, icon, actions, sx }) => (
  <Box
    sx={[
      { display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', columnGap: 2, rowGap: 1.5, mb: 3 },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0, flex: '1 1 260px' }}>
      {icon && <Box sx={{ display: 'flex', color: 'primary.main', fontSize: 28 }}>{icon}</Box>}
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" component="h1">{title}</Typography>
        {subtitle && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{subtitle}</Typography>}
      </Box>
    </Box>
    {actions && (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, '& > *': { flexShrink: 0 } }}>
        {actions}
      </Box>
    )}
  </Box>
);

export default PageHeader;
